import { useEffect, useState } from 'preact/hooks';
export const useComponent = (map, name) => {
    const [importedComponent, setImportedComponent] = useState(undefined);
    useEffect(() => {
        const importFn = map[name];
        if (importFn && typeof importFn === 'function') {
            const componentFn = importFn();
            if (componentFn instanceof Promise) {
                componentFn.then((component) => {
                    setImportedComponent(() => component);
                });
            }
            else {
                setImportedComponent(() => componentFn);
            }
        }
    }, []);
    return importedComponent;
};
